import { AUTH_BASE_URL } from '../utils/ApiUrls';

class AuthService {
  // Login method
  async login(email, password) {
    try {
      const response = await fetch(`${AUTH_BASE_URL}/login/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          password: password,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Login failed',
          errorData: data, // Include the full error data for field-specific errors
        };
      }

      return {
        success: true,
        status: response.status,
        data: data,
      };

    } catch (error) {
      return {
        success: false,
        status: 0, // 0 indicates network error
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Refresh token method
  async refreshToken(refreshToken) {
    try {
      console.log('AuthService: Sending refresh token request...');
      const response = await fetch(`${AUTH_BASE_URL}/token/refresh/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          refresh: refreshToken,
        }),
      });

      const data = await response.json();
      // console.log('AuthService: Refresh response:', response.status, data);

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Token refresh failed',
          errorData: data,
        };
      }

      // CRITICAL FIX: Handle token rotation properly
      // When ROTATE_REFRESH_TOKENS is True, Django returns both access and refresh tokens
      return {
        success: true,
        status: response.status,
        access_token: data.access,
        refresh_token: data.refresh, // This will be the new refresh token when rotation is enabled
      };

    } catch (error) {
      console.error('AuthService: Network error during token refresh:', error);
      return {
        success: false,
        status: 0,
        error: error.message || 'Token refresh failed',
        errorData: null,
      };
    }
  }


  // Logout method
  async logout(accessToken, refreshToken) {
    try {
      console.log('AuthService: Calling logout API...');
      const response = await fetch(`${AUTH_BASE_URL}/logout/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          refresh: refreshToken,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        console.warn('Logout API failed, but continuing with frontend logout');
        return {
          success: false,
          status: response.status,
          error: data.error || data.detail || 'Logout logging failed',
          errorData: data,
        };
      }

      console.log('AuthService: Logout logged successfully');
      return {
        success: true,
        status: response.status,
        data,
      };

    } catch (error) {
      console.warn('Logout API error, but continuing with frontend logout:', error);
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error during logout',
        errorData: null,
      };
    }
  }





  // Request password reset
async requestPasswordReset(email) {
  try {
    const response = await fetch(`${AUTH_BASE_URL}/password-reset/request/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        status: response.status,
        error: data.error || 'Password reset request failed',
        errorData: data,
      };
    }

    return {
      success: true,
      status: response.status,
      data: data,
    };

  } catch (error) {
    return {
      success: false,
      status: 0,
      error: error.message || 'Network error occurred',
      errorData: null,
    };
  }
}

// Verify reset token
async verifyResetToken(token) {
  try {
    const response = await fetch(`${AUTH_BASE_URL}/password-reset/verify/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token }),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        status: response.status,
        error: data.error || 'Token verification failed',
        errorData: data,
      };
    }

    return {
      success: true,
      status: response.status,
      data: data,
    };

  } catch (error) {
    return {
      success: false,
      status: 0,
      error: error.message || 'Network error occurred',
      errorData: null,
    };
  }
}

// Reset password
async resetPassword(token, password) {
  try {
    const response = await fetch(`${AUTH_BASE_URL}/password-reset/reset/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token, password }),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        status: response.status,
        error: data.error || 'Password reset failed',
        errorData: data,
      };
    }

    return {
      success: true,
      status: response.status,
      data: data,
    };

  } catch (error) {
    return {
      success: false,
      status: 0,
      error: error.message || 'Network error occurred',
      errorData: null,
    };
  }
}



}

// Export a single instance
const authService = new AuthService();
export default authService;